import { useCallback, useEffect } from 'react';
import { Card, CardContent, Icon, Typography } from '@material-ui/core';

// local imports
import { useDataApi } from 'app/hooks';
import { PharmacyService } from 'app/services';
import { FormatUtils, Mapper } from 'app/utils';
import { mapActivationStatus } from 'app/utils/mapper';
import { Loader, NoDataTableComponent } from 'app/components/atoms';

const SupportFormDetail = ({ formId }) => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    const out = {};

    const data = await PharmacyService.getCustomerSupportFormDetail(formId);
    const { created_at, status, id, pharmacy, subject, ...rest } = data.data.data;

    out.data = {
      ...rest,
      time: FormatUtils.convertDateString(created_at),
      pharmacyName: pharmacy.name,
      status: mapActivationStatus(status.id),
      subject: Mapper.customerSupportSubjects(subject.id)
    };

    return out;
  }, [formId]);

  useEffect(() => setService(() => fetchData()), [fetchData, setService]);

  // variables
  const isDataLoading = !service.data && (!service.isInitialized || service.isLoading);
  const isDataExist = !!service.data && !service.isNetworkError && !service.isError;
  const apiURL = process.env.REACT_APP_API;

  // support form datas
  const { pharmacyName, time, subject, description, content_url } =
    !!service.data && service?.data?.data;

  if (isDataLoading) return <Loader loading={isDataLoading} />;

  return (
    <>
      <Card elevation={4}>
        <CardContent>
          {isDataExist ? (
            <>
              <div className="flex justify-between space-x-16 items-center pb-8 border-b">
                <div>
                  <Icon size="large">attach_email</Icon>
                </div>
                <div className="flex-1 ">
                  <Typography variant="h6" className="text-gray-800 font-semibold tracking-wider">
                    {pharmacyName || '-'}
                  </Typography>
                  <Typography variant="subtitle2" className="text-gray-600 text-12">
                    {time || '-'}
                  </Typography>
                </div>
              </div>

              <div className="py-8">
                <Typography
                  variant="subtitle1"
                  className="font-semibold text-gray-800 mb-8 truncate">
                  Konu: {subject || '-'}
                </Typography>
                <Typography variant="body1" className="text-14 text-gray-800 break-words">
                  {description || '-'}
                </Typography>
              </div>

              {!!content_url && (
                <div className="border-t overflow-hidden pt-16">
                  <img
                    src={`${apiURL}/${content_url}`}
                    alt="support content"
                    className="w-full h-full rounded-8"
                  />
                </div>
              )}
            </>
          ) : (
            <NoDataTableComponent />
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default SupportFormDetail;
